module.exports = __webpack_public_path__ + "teqbahn-assets/media/pc3.59f71286.png";